// src/pages/PostDetail/PostDetailPage.jsx
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spin, message } from "antd";
import BlogLayout from "../../components/BlogLayout";
import BlogPostDetail from "../../components/BlogPostDetail";
import Comments from "../../components/Comments";
import { usePost, useAuth } from "../../hooks/useBlogAPI";
import "./PostDetailPage.css";

const PostDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { data: post, loading, refresh } = usePost(id);

  const handleEdit = () => {
    navigate(`/posts/${id}/edit`);
  };

  const handleDelete = async () => {
    try {
      // 这里应该调用删除API
      message.success("文章删除成功");
      navigate("/");
    } catch (error) {
      message.error("删除失败: " + error.message);
    }
  };

  const handleAddComment = async (commentData) => {
    try {
      // 这里应该调用添加评论API
      await new Promise((resolve) => setTimeout(resolve, 500)); // 模拟API调用
      message.success("评论发表成功");
      refresh(); // 刷新文章数据以显示新评论
    } catch (error) {
      message.error("评论发表失败: " + error.message);
    }
  };

  return (
    <BlogLayout user={user}>
      <div className="container">
        <Spin spinning={loading}>
          {post && (
            <>
              <BlogPostDetail
                post={post}
                onEdit={handleEdit}
                onDelete={handleDelete}
              />
              <div style={{ marginTop: 24 }}>
                <Comments
                  comments={post.comments || []}
                  onSubmit={handleAddComment}
                />
              </div>
            </>
          )}
        </Spin>
      </div>
    </BlogLayout>
  );
};

export default PostDetailPage;
